import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { checkIcon, warningIcon } from 'src/app/app-icons';
import { TenantSubscriberModel } from 'src/app/models/subscription/tenant-subscriber.model';

@Component({
  selector: 'app-subscriber-selector',
  standalone: false,
  templateUrl: './subscriber-selector.component.html',
  styleUrl: './subscriber-selector.component.scss',
})
export class SubscriberSelectorComponent {
  @ViewChild('subscriptionsTree') 
  subscriptionsTree!: DxTreeViewComponent;

  @Input() subscriptionIds: string[] = [];
  @Output() subscriptionIdsChange = new EventEmitter<string[]>();

  @Input() subscribers: TenantSubscriberModel[] = [];
  @Input() isViewMode = false;

  get areAllSubscribersSelected(): boolean {
    return (
      this.subscriptionIds.length > 0 &&
      this.subscriptionIds.length === this.subscribers.length
    );
  }

  constructor(
    private translateService: TranslateService,
    private sanitized: DomSanitizer,
  ) {
  }

  getSubscribersVisibleInText(): string {
    const subscribers = this.subscribers
      .filter(s => this.subscriptionIds.includes(s.subscriptionId))
      .map(s => s.title)
      .join(', ');

    return this.translateService.instant(
      'TARGET-GROUP.PUBLISH-TRAINING.VISIBLE-TO-SUBSCRIBERS',
      { subscribers }
    );
  }

  getWarningIcon() {
    return this.sanitized.bypassSecurityTrustHtml(warningIcon);
  }

  getCheckIcon() {
    return this.sanitized.bypassSecurityTrustHtml(checkIcon);
  }
  
  onSubscriptionsSelectAllChanged(e: any): void {
    this.subscriptionIds = e.component.getSelectedNodeKeys();
    this.subscriptionIdsChange.emit(this.subscriptionIds);

    this.setTreeViewValues();
  }

  onSubscriptionSelected(e: any) {
    if (e.node.selected) {
      this.subscriptionIds = [
        ...this.subscriptionIds,
        e.node.key,
      ];
    } else {
      this.subscriptionIds = this.subscriptionIds.filter(
        (id) => id !== e.node.key
      );
    }

    this.subscriptionIdsChange.emit(this.subscriptionIds);
  }

  onSubscriptionsValueChanged(e: any): void {
    if (e.value === null) {
      this.subscriptionIds = [];
      this.subscriptionIdsChange.emit(this.subscriptionIds);

      this.subscriptionsTree?.instance.unselectAll();
      this.setTreeViewValues();
    }
  }

  setTreeViewValues(): void {
    this.subscribers.forEach((subscriber) => {
      subscriber.selected = this.subscriptionIds.includes(
        subscriber.subscriptionId
      );
    });
  }
}
